import { useModal } from '../modules/modal'

function handleInfo(msg: string) {
  const modalService = useModal()

  // eslint-disable-next-line no-console
  console.log(msg)

  // default handling + unhandled error types
  modalService.show({
    type: 'info',
    title: 'Information',
    body: `<b>${msg.replaceAll('\n', '<br>')}</b>`,
    primary: {
      label: 'OK',
      theme: 'white',
      action: () => undefined,
    },
  })
  return Promise.resolve()
}

function handleWarning(msg: string) {
  const modalService = useModal()

  console.warn(msg)

  // default handling + unhandled error types
  modalService.show({
    type: 'warning',
    title: 'Warnung',
    body: `<b>${msg.replaceAll('\n', '<br>')}</b>`,
    primary: {
      label: 'OK',
      theme: 'yellow',
      action: () => undefined,
    },
  })
  return Promise.resolve()
}

function handleConfirm(msg: string, btnOk?: string) {
  const modalService = useModal()

  return new Promise((resolve) => {
    modalService.show({
      type: 'info',
      title: 'Bestätigung',
      body: `<b>${msg.replaceAll('\n', '<br>')}</b>`,
      primary: {
        label: btnOk || 'Bestätigen',
        theme: 'blue',
        action: () => {
          resolve(true)
        },
      },
      secondary: {
        label: 'Abbrechen',
        theme: 'white',
        action: () => {
          resolve(false)
        },
      },
    })
  })
}

function handleError(msg?: string, error?: Error) {
  const modalService = useModal()
  let errorMsg = msg

  // eslint-disable-next-line no-console
  console.log(error, msg)

  if (error && !msg)
    errorMsg = JSON.stringify(error, null, 2).replaceAll('\n', '<br>')
  if (error && msg)
    errorMsg = `${msg}\n\n${JSON.stringify(error, null, 2)}`.replaceAll('\n', '<br>')

  if (error && (error as any).response && (error as any).response.status && (error as any).response.status === 401) {
    (error as any).done = true

    modalService.show({
      type: 'danger',
      title: 'Fehler',
      body: '<b>Es ist ein Fehler aufgetreten.<br>Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.</b>',
      error: errorMsg,
      primary: {
        label: 'OK',
        theme: 'red',
        action: () => undefined,
      },
    })
    location.reload()
  }

  // Netzwerkfehler, Kein Internet, Internet unterbrochen usw.
  if (error && (error as any).code === 'ERR_NETWORK') {
    (error as any).done = true

    modalService.show({
      type: 'danger',
      title: 'Fehler',
      body: '<b>Es ist ein Fehler aufgetreten.<br>Der Server ist nicht erreichbar oder es gibt ein Problem mit Ihrer Verbindung.<br>Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.</b>',
      error: errorMsg,
      primary: {
        label: 'OK',
        theme: 'red',
        action: () => undefined,
      },
    })
  }
  else {
    // default handling + unhandled error types
    modalService.show({
      type: 'danger',
      title: 'Fehler',
      body: `<b>${msg ? msg.replaceAll('\n', '<br>') : 'Es ist ein Fehler aufgetreten.'}</b>`,
      error: msg === errorMsg ? undefined : errorMsg,
      primary: {
        label: 'OK',
        theme: 'red',
        action: () => undefined,
      },
    })
  }
}

// these APIs are auto-imported from @vueuse/core
export const modal = {
  handleInfo,
  handleWarning,
  handleConfirm,
  handleError,
}
